<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="container card-body table-responsive">
        <div class="row">
          <div class="col-md-12">
            <div id="accordion" class="mb-3">
              <div class="card mb-1" *ngFor="let row of dataIndicadoresLineas; let indiceUno=index">
                <div class="card-header py-0 px-0 my-0" id="abc">
                  <h5 class="accordion-header py-0" id="abc">
                    <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#id_{{indiceUno + 1}}"
                      aria-expanded="true">
                      {{"LINEA ACCIÓN " + (indiceUno+1) + ".- "}}{{
                      row.nombreLineaAccion }}
                    </a>
                  </h5>
                </div>
                <div id="id_{{indiceUno + 1}}" class="collapse" aria-labelledby='abcd' data-bs-parent="#accordion">
                  <div class="card-body">

                    <div class="row">
                      
                      <div class="form-group row mb-2">
                        <div class="col col-md-9 text-md-right">
                          <div *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}">
                          <button *hasPermission="{app: constant.INDICADORES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect pl-4"
                          (click)="openModal(row)"><i class="fas fa-plus fa-lg mr-1"></i>
                          Nuevo</button>
                        </div>
                        </div>
                        <!--<div class="col-14 col-md-3">
                          <button type="button" class="btn btn-sm btn-secondary waves-effect pl-4"
                          (click)="procesarPeso(row.indicadores)"><i class="fas fa-plus fa-lg mr-1"></i>
                          Procesar peso</button>
                        </div>-->
                      </div>
                    </div>

                    <div class="container card-body table-responsive pt-2">
                      <table class="table table-striped table-bordered row-border hover">
                        <thead>
                          <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Fecha inicio</th>
                            <th>Estado</th>
                            <th>Configuración</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let rowDataLinea of row.indicadores; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{rowDataLinea.nombre}}</td>
                            <td>{{rowDataLinea.fechaInicio | date : "dd-MM-yyyy"}}</td>
                            <td>{{((rowDataLinea.estado == '1')? 'Activo': 'Inactivo')}}</td>
              
                            <td class="text-center">
                              <div class="row">
                                <button type="button" tooltip="Editar"
                                  class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                  title="Configuración y cumplimiento indicador." (click)="configuracionInit(rowDataLinea)">
                                  <i class="fas fa-cog fa-lg"></i>
                                </button>
                              </div>
                            </td>

                            <td class="text-center">
                              <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}">
                                <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar"
                                  class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                  title="Editar este registro" (click)="edit(rowDataLinea, row)">
                                  <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>

                                <button *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                  title="Eliminar este registro" (click)="delete(rowDataLinea)">
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                              </div>

                              <div class="row" *hasDeniedItems="{idSprAmbiente:idSprAmbiente, itemElemento:rowDataLinea.idSprIndicador, tipoElemento:'indicador'}">
                                <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar"
                                  class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                  title="Editar este registro" (click)="edit(rowDataLinea, row)">
                                  <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>

                                <button *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                  title="Eliminar este registro" (click)="delete(rowDataLinea)">
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                              </div>

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-lineaAccion" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<!-- ############################################################################################################# -->
<!-- ######################################    MODALES       ##################################################### -->
<!-- ############################################################################################################# -->

<jw-modal id="{{nameModal}}">
  <!-- MODAL PARA CREAR Y EDITAR -->
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{ nameApp }}</h3>
        <button type="button" class="btn-close" (click)="modal.close();" aria-label="Close"></button>
      </div>
      <div class="modal-body pT-4">
        <div class="card-header  mb-2">
          <div class="form-group row mb-2">
            <div  class="texto-justificado">
              <span><b>LÍNEA DE ACCIÓN: </b>{{nombreLineaAccion}}</span>
            </div>
          </div>
        </div>
        <form action="#" [formGroup]="formLineaAccionIndicadores" class="needs-validation">
          <div class="row">

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="nombre" class="form-control-label text-md-right pt-1"><b>Nombre:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <input type="hidden" id="idSprIndicador" formControlName="idSprIndicador" requiered
                  class="is-invalid" />
                  <textarea class="form-control" maxlength="500" id="nombre" placeholder="Nombre"
                  formControlName="nombre" required="true"
                  [ngClass]="{'is-invalid': this.formLineaAccionIndicadores.get('nombre')?.errors && this.submitted,  'is-valid': !this.formLineaAccionIndicadores.get('nombre')?.errors,}">
                </textarea>
                <div class="col text-danger">
                  <span class="font-italic"
                    *ngIf="this.formLineaAccionIndicadores.get('nombre')?.errors?.['required'] && this.submitted">Campo
                    requerido</span>
                </div>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="descripcion" class=" form-control-label text-md-right pt-1"><b>Descripción:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <textarea class="form-control" maxlength="500" id="descripcion" placeholder="Descripción"
                  formControlName="descripcion"
                  [ngClass]="{ 'is-invalid': this.formLineaAccionIndicadores.get('descripcion')?.errors && this.submitted,'is-valid': this.formLineaAccionIndicadores.value.descripcion}">
                </textarea>
                <div class="col text-danger">
                </div>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="unidadInformacion" class=" form-control-label text-md-right pt-1"><b>Fuente:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <textarea class="form-control" maxlength="250" id="unidadInformacion" placeholder="Fuente"
                  formControlName="unidadInformacion"
                  [ngClass]="{ 'is-invalid': this.formLineaAccionIndicadores.get('unidadInformacion')?.errors &&  !this.formLineaAccionIndicadores,'is-valid': this.formLineaAccionIndicadores.value.unidadInformacion}">
                </textarea>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="idSprEquipoGerencial"
                  class=" form-control-label text-md-right pt-1"><b>Responsable:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <select class="form-select col-9" id="idSprEquipoGerencial" formControlName="idSprEquipoGerencial"
                  required="true"
                  [ngClass]="{'is-invalid': this.formLineaAccionIndicadores.get('idSprEquipoGerencial')?.errors && this.submitted, 'is-valid': !this.formLineaAccionIndicadores.get('idSprEquipoGerencial')?.errors,}">
                  <option value=" ">Seleccione</option>
                  <option *ngFor="let row of dataResponsableProceso" value={{row.idSprEquipoGerencial}}>
                    {{row.nombres}}
                  </option>
                </select>
                <div class="col text-danger">
                  <span class="font-italic"
                    *ngIf="this.formLineaAccionIndicadores.get('idSprEquipoGerencial')?.errors?.['required'] && this.submitted">Campo
                    requerido</span>
                </div>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="fechaInicio" class=" form-control-label text-md-right"><b>Fecha inicio:</b></label>
              </div>
              <div class="col-12 col-md-4">
                <input type="date" class="form-control" required="true" placeholder="fechaInicio"
                  formControlName="fechaInicio"
                  [ngClass]="{'is-invalid': this.formLineaAccionIndicadores.get('fechaInicio')?.errors && this.submitted,'is-valid': !this.formLineaAccionIndicadores.get('fechaInicio')?.errors,}"
                  date>
                <div class="col text-danger">
                  <span class="font-italic"
                    *ngIf="this.formLineaAccionIndicadores.get('fechaInicio')?.errors?.['required'] && this.submitted">Campo
                    requerido</span>
                  <span class="font-italic"
                    *ngIf="this.formLineaAccionIndicadores.get('fechaInicio').errors?.fechaInicio">La
                    fecha debe estar comprendida entre
                    {{this.formLineaAccionIndicadores.get('fechaInicio')?.errors.fechaInicio}}
                    y {{this.formLineaAccionIndicadores.get('fechaInicio')?.errors.fechaFin}}
                  </span>
                </div>
              </div>

              <div class="col col-md-1 text-md-right ">
                <label for="estado" class="form-control-label text-md-right pt-1"><b>Estado:</b></label>
              </div>
              <div class="col-12 col-md-5">
                <select class="form-select " id="estado" formControlName="estado" required="true"
                  [ngClass]="{'is-invalid': this.formLineaAccionIndicadores.get('estado')?.errors && this.submitted,'is-valid': !this.formLineaAccionIndicadores.get('estado')?.errors,}">
                  <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                  </option>
                </select>
                <div class="col text-danger">
                  <small class="font-italic"
                    *ngIf="this.formLineaAccionIndicadores.get('estado')?.errors?.['required'] && this.submitted">Campo
                    requerido</small>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>
<jw-modal id="{{modalAdversoLinea}}">
  <h3 class="modal-title">{{desripcionLineaAccion}}</h3>
  <div class="modal-dialog modal-xl modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <button type="button" class="btn-close" (click)="modal.closeId(modalAdversoLinea);" aria-label="Close"></button>
      </div>
      <div class="modal-body ">
        <app-config-agrupa-indicadores [init]="dataIndicadorSendConfig"></app-config-agrupa-indicadores>
      </div>
    </div>
  </div>
</jw-modal>